import { render, staticRenderFns } from "./MyContractsIndex.vue?vue&type=template&id=353ceb02"
import script from "./MyContractsIndex.vue?vue&type=script&lang=js"
export * from "./MyContractsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports